var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { attrs: { "aria-labelledby": "searchTitle" } },
    [
      _vm.otherSourcesTab
        ? _c("section", { staticClass: "section" }, [
            _c("div", { staticClass: "tabs flex--justifyContent-center" }, [
              _c(
                "button",
                {
                  staticClass: "tabs__tab tabs__tab--large",
                  class: { "tabs__tab--active": _vm.customTab === "statista" },
                  attrs: {
                    type: "button",
                    "data-hash": "statista",
                    rel: "searchForm",
                    "data-gtm": "searchTab__statista",
                  },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.checkTab("statista")
                    },
                    click: function ($event) {
                      return _vm.checkTab("statista")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "tabs__icon",
                      attrs: {
                        viewBox: "0 0 64 64",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M61.8 0H2.2C1 0 0 1 0 2.3V43h.3s9.7-.2 13.8-2.4c5.1-2.7 9-8.2 9-8.2l2.3-3.4.8-1c0-.2.4-.8.7-1.1l2.2-3.2s5.8-8.4 14-12.7C52.1 6.4 63.8 7 63.8 7h.2V2.3C64 1 63 0 61.8 0M49.6 23.4c-5 2.7-8.9 8.2-8.9 8.2L38.4 35l-.8 1.1-.7 1-2.2 3.2s-5.8 8.4-14 12.7A47.2 47.2 0 0 1 0 57.1v4.7C0 63 1 64 2.2 64h59.6c1.2 0 2.2-1 2.2-2.2V21h-.6s-9.6.3-13.8 2.4",
                          fill: "#0f2741",
                          "fill-rule": "evenodd",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "vertical-middle" }, [
                    _vm._v("Statista"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.dataHasGcs
                ? _c(
                    "button",
                    {
                      staticClass: "tabs__tab tabs__tab--large",
                      class: {
                        "tabs__tab--active": _vm.customTab === "google",
                      },
                      attrs: {
                        type: "button",
                        "data-hash": "google",
                        rel: "search__google",
                        "data-gtm": "searchTab__google",
                      },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.checkTab("google")
                        },
                        click: function ($event) {
                          return _vm.checkTab("google")
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "tabs__icon",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            viewBox: "0 0 48 48",
                          },
                        },
                        [
                          _c("defs", [
                            _c("path", {
                              attrs: {
                                id: "tabsGoogleLogoPath",
                                d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "clipPath",
                            { attrs: { id: "tabsGoogleLogoClipPath" } },
                            [
                              _c("use", {
                                attrs: {
                                  "xlink:href": "#tabsGoogleLogoPath",
                                  overflow: "visible",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              "clip-path": "url(#tabsGoogleLogoClipPath)",
                              fill: "#FBBC05",
                              d: "M0 37V11l17 13z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              "clip-path": "url(#tabsGoogleLogoClipPath)",
                              fill: "#EA4335",
                              d: "M0 11l17 13 7-6.1L48 14V0H0z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              "clip-path": "url(#tabsGoogleLogoClipPath)",
                              fill: "#34A853",
                              d: "M0 37l30-23 7.9 1L48 0v48H0z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              "clip-path": "url(#tabsGoogleLogoClipPath)",
                              fill: "#4285F4",
                              d: "M48 48L17 24l-4-3 35-10z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "vertical-middle" }, [
                        _vm._v("Google"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dataHasKcs
                ? _c(
                    "button",
                    {
                      staticClass: "tabs__tab tabs__tab--large",
                      class: { "tabs__tab--active": _vm.customTab === "kobra" },
                      attrs: {
                        "data-hash": "kobra",
                        rel: "search__kobra",
                        "data-gtm": "searchTab__kobra",
                        type: "button",
                      },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.checkTab("kobra")
                        },
                        click: function ($event) {
                          return _vm.checkTab("kobra")
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "tabs__icon",
                          attrs: {
                            id: "kobraIcon",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 32 32",
                          },
                        },
                        [
                          _c("g", [
                            _c("path", {
                              attrs: {
                                fill: "#e2001a",
                                d: "M16.65,8.26l0,0c.25-.36.15-.63,0-.77L14.08,5.86a.68.68,0,0,1-.3-.56c0-.37.22-.65.72-.79a61.58,61.58,0,0,1,9.11-.66c.66,0,1.8,0,2.82,0l0,0A16,16,0,0,0,3.69,26.22c2-2.89,7-10,8.06-11.47,1.25-1.68,4.11-5.41,4.59-6l0,0Z",
                                transform: "translate(0 0)",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                fill: "#e2001a",
                                d: "M6.24,28.68A16,16,0,0,0,30.18,8.59h0A2.18,2.18,0,0,0,31,6.17,7,7,0,0,0,30,5l0,.06a2.2,2.2,0,0,1-.93,2.42c-.3.27-4.37,4.1-9.13,8.27-4.2,3.67-8.9,7.41-11.62,9.44C4.55,28,3.81,28.44,3.81,28.44a.88.88,0,0,1-.39.11.71.71,0,0,1-.57-.28h0v.12c.41.66,1.09,1.44,1.48,1.44a.88.88,0,0,0,.4-.11s.3-.16,1.52-1",
                                transform: "translate(0 0)",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                fill: "#fff",
                                d: "M16.68,8.22a.55.55,0,0,0,0-.77L14.07,5.86a.68.68,0,0,1-.3-.56c0-.37.22-.65.72-.79a61.78,61.78,0,0,1,9.11-.66c.9,0,2.68,0,3.86.07s2.31.36,2.56,1a2.18,2.18,0,0,1-.89,2.54c-.31.27-4.37,4.1-9.13,8.27-4.2,3.67-8.9,7.41-11.62,9.45C4.55,28,3.81,28.45,3.81,28.45a1.07,1.07,0,0,1-.4.1.7.7,0,0,1-.71-.7.74.74,0,0,1,.13-.41s7.54-10.86,8.91-12.69S16.4,8.62,16.4,8.62l.28-.4",
                                transform: "translate(0 0)",
                              },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "vertical-middle" }, [
                        _vm._v("KoBra"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "h1",
        { staticClass: "visually-hidden", attrs: { id: "searchTitle" } },
        [_vm._v("\n        " + _vm._s(_vm.trans("SEARCH")) + "\n    ")]
      ),
      _vm._v(" "),
      _c("search-content", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.customTab === "statista",
            expression: "customTab === 'statista'",
          },
        ],
        attrs: {
          "id-basic": _vm.idBasic,
          "id-standard": _vm.idStandard,
          "selected-categories-value": _vm.selectedCategoriesValue,
        },
      }),
      _vm._v(" "),
      _c("div", { key: _vm.key }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.otherSourcesTab &&
                  _vm.dataHasGcs &&
                  _vm.customTab === "google",
                expression:
                  "otherSourcesTab && dataHasGcs && customTab === 'google'",
              },
            ],
            staticClass: "tabContent",
            attrs: { id: "search__google" },
          },
          [
            _c(
              "section",
              {
                staticClass:
                  "section bg-light padding-horizontal-50 padding-vertical-50 padding-horizontal-s-0 padding-bottom-s-20 padding-vertical-s-30 border-bottom-gray20-1",
                attrs: { id: "googleCustomSearch" },
              },
              [
                _c("div", { staticClass: "flex text-center" }, [
                  _c(
                    "div",
                    {
                      pre: true,
                      attrs: {
                        class:
                          "width100 padding-horizontal-30 padding-horizontal-s-0",
                      },
                    },
                    [_c("gcse:searchbox", { pre: true })],
                    1
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { pre: true },
              [
                _c("gcse:searchresults", { pre: true }, [
                  _c(
                    "div",
                    {
                      pre: true,
                      attrs: { class: "center padding-vertical-15" },
                    },
                    [
                      _c("img", {
                        pre: true,
                        attrs: {
                          ":src": "getCdnLink('img/preloaders/preloader.gif')",
                          width: "20",
                          height: "20",
                          class: "display-inline-block",
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm._m(0),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.otherSourcesTab &&
                  _vm.dataHasKcs &&
                  _vm.customTab === "kobra",
                expression:
                  "otherSourcesTab && dataHasKcs && customTab === 'kobra'",
              },
            ],
            staticClass: "tabContent",
            attrs: {
              d: "search__kobra",
              "data-tabbar-content": "search__kobra",
            },
          },
          [
            _c(
              "section",
              {
                staticClass:
                  "section bg-light padding-horizontal-50 padding-vertical-50 padding-horizontal-s-0 padding-bottom-s-20 padding-vertical-s-30 border-bottom-gray20-1",
                attrs: { id: "kobraCustomSearch" },
              },
              [_c("KobraSearchbar")],
              1
            ),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "width33 hideMobile" }, [
                  _c(
                    "section",
                    {
                      staticClass:
                        "section section__searchFilter row margin-bottom-40 padding-top-0",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "padding-top-20" },
                        [
                          _c("kobra-filter", {
                            on: {
                              changebranchgroup: function ($event) {
                                _vm.selectedKobraBranchGroup = $event
                              },
                              changeinfotype: function ($event) {
                                _vm.selectedKobraInfoType = $event
                              },
                              changesearchtype: function ($event) {
                                _vm.selectedKobraSearchType = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(1),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "width66" }, [
                  _c(
                    "div",
                    { staticClass: "padding-all-20 padding-horizontal-s-0" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "h4",
                          { staticClass: "h3 font-size-s-110 bold showMobile" },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.trans("SEARCH_RESULTS")) +
                                "\n                                    "
                            ),
                            _c("span", { staticClass: "text-normal" }, [
                              _vm._v(_vm._s(_vm.totalFoundSumRegion)),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("KobraResults"),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { pre: true, attrs: { class: "hide" } }, [
      _c(
        "div",
        {
          pre: true,
          attrs: { class: "noResults", "data-gcse-no-results": "" },
        },
        [
          _vm._v(
            "\n                        {{ trans('SEARCH_ENTER_TERM') }}\n                    "
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "row text-center padding-right-15" }, [
      _c("div", { attrs: { id: "dc-content" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }